/**
 * Coarse "is this a phone-class device" check.
 *
 * We use it to back off the memory-hungry bits on mobile: a phone has far less
 * GPU/RAM headroom than a desktop, so the big raw-GeoJSON charts can render for a
 * moment then lose the WebGL context and go white. Prefer the UA-Client-Hints
 * `mobile` flag where the browser gives it (Chrome on Android does), and fall
 * back to a user-agent sniff otherwise.
 */
interface UaDataLike {
  mobile?: boolean;
}

export function isMobileDevice(): boolean {
  if (typeof navigator === 'undefined') return false;
  const uaData = (navigator as Navigator & { userAgentData?: UaDataLike }).userAgentData;
  if (uaData && typeof uaData.mobile === 'boolean') return uaData.mobile;
  return /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);
}
